//
// tagifyのラッパーメソッド
// - options: maxTags - 最大タグ数制限
//
// エレメントのdata-actionにホワイトリスト取得APIのURLを設定する
//
window.initalizeTagify = function(selector, options) {
    options = options || {};
    var tagify = null;
    var input = document.querySelector(selector);
    if (input) {
        input.setAttribute('type', 'text');
        // var tagify = new Tagify(input);
        // new Tagify(input, {
        //     originalInputValueFormat: valuesArr => valuesArr.map(item => item.value).join(',')
        // });
        tagify = new Tagify(input, {
            // 必要に応じて、ホワイトリストを強制するかどうかを設定
            enforceWhitelist: false,
            // 最初は空のリスト
            whitelist: [],
            tagTextProp: 'value',
            skipInvalid: true,
            dropdown: {
                enabled: 1,
                maxItems: 20
            },
        });
        if (options.maxTags) {
            tagify.settings.maxTags = options.maxTags;
        }
        var tagifyURL = input.getAttribute('data-action');
        if (tagifyURL) {
            var tagifyTimer;
            var tagifyDelay = 300;
            tagify.on('input', function(e) {
                clearTimeout(tagifyTimer);
                var value = e.detail.value;
                tagifyTimer = setTimeout(function() {
                    // 入力内容が変わるたびにタグを検索
                    fetch(tagifyURL + '?term=' + value)
                        .then(res => res.json())
                        .then(function(data){
                            // 検索結果をホワイトリストとして設定
                            tagify.settings.whitelist = data;
                            // 再度ドロップダウンを開く
                            tagify.dropdown.show(value);
                        });
                }, tagifyDelay);
            });
        }
        tagify.on('appendTags', function(tags) {
            console.log(tags);
        });
    }
    return tagify;
};
